import script from "./SoffitFascia06Paint.vue?vue&type=script&setup=true&lang=js"
export * from "./SoffitFascia06Paint.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__